import { render, staticRenderFns } from "./HorizontalNavMenuHeaderGroup.vue?vue&type=template&id=f2299af2&"
import script from "./HorizontalNavMenuHeaderGroup.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuHeaderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports